import { combineReducers } from "redux"

import { setterReducer } from "../common/redux"
import * as t from "./actionTypes"

const customSubmitted = setterReducer(null, t.SET_CUSTOM_SUBMITTED)
const customDiagnosis = setterReducer(null, t.SET_CUSTOM_TAG)
const query = setterReducer("", t.SET_DIAGNOSIS_QUERY)
const suggestions = (state = { items: [], active: -1 }, action) => {
  switch (action.type) {
    case t.SET_DIAGNOSIS_SUGGESTIONS:
      return { items: action.payload, active: -1 }
    case t.INCREMENT_DIAGNOSIS_SUGGESTION:
      return {
        ...state,
        active: state.active >= state.items.length - 1 ? 0 : state.active + 1,
      }
    case t.DECREMENT_DIAGNOSIS_SUGGESTION:
      return {
        ...state,
        active: state.active <= 0 ? state.items.length - 1 : state.active - 1,
      }
    default:
      return state
  }
}

const custom = combineReducers({
  suggestions,
  diagnosis: customDiagnosis,
  query,
  submitted: customSubmitted,
})

const diagnosis = setterReducer(null, t.SET_DIAGNOSIS_TAG)
const doctor = setterReducer(null, t.SET_DOCTOR_TAG)
const finished = setterReducer(null, t.SET_TAGGING_FINISHED)

const tagging = combineReducers({
  diagnosis,
  doctor,
  customSubmitted,
  custom,
  finished,
})

export { tagging as default }



// WEBPACK FOOTER //
// ./assets/feedback/tagging.js